import classNames from 'classnames';
import * as React from 'react';

// Constants
import { AGREEMENT_TYPE, DOWNLOAD_TYPE } from '../constants';

// Modules
import { DI } from 'modules';

const DownloadSliderHints = ({ agreement, common, hints, isRepeated }) => {
  const { strings } = common;
  const rootCln = 'side-popup-buttons__text';
  const prefix = 'page.video.slider';
  const isOneOff = agreement.agreement_type === AGREEMENT_TYPE.ONE_OFF;
  const isDownloaded = !hints.length && isRepeated;

  return (
    <div
      className={classNames(rootCln, {
        [`${rootCln}--downloaded`]: isDownloaded
      })}
    >
      {isDownloaded && (
        <span>
          {strings[`${prefix}.repeated_text${isOneOff ? '.one_off' : ''}`]}
        </span>
      )}

      {!!hints.length && (
        <>
          {strings[`${prefix}.choose`]} {hints.join(', ')}{' '}
          {strings[`${prefix}.download_video`]}.
        </>
      )}
    </div>
  );
};

export default DI(['common'])(DownloadSliderHints);
